import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-5 mt-5">
      <Container>
        <Row className="gy-4">
          {/* BRAND / ABOUT */}
          <Col md={3}>
            <h5 className="fw-bold text-accent">SEPL</h5>
            <p className="small"></p>
          </Col>

          {/* NAVIGATION LINKS */}
          <Col md={2}>
            <h6 className="fw-semibold">Support</h6>
            <ul className="list-unstyled small">
              <li>
                <Link to="/" className="text-light text-decoration-none">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="text-light text-decoration-none">
                  Blogs
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  className="text-light text-decoration-none"
                >
                  Resources
                </Link>
              </li>
              <li>
                <Link
                  to="/contactus"
                  className="text-light text-decoration-none"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </Col>

          {/* Social */}
          <Col md={2}>
            <li>
              <Link
                to="/privacy-policy"
                className="text-light text-decoration-none"
              >
                Privacy Policy
              </Link>
            </li>
            {/*<h6 className="fw-semibold">Follow Us</h6>
            <div className="d-flex gap-3">
              <a href="#" className="text-light text-decoration-none">
                Facebook
              </a>
              <a href="#" className="text-light text-decoration-none">
                Twitter
              </a>
              <a href="#" className="text-light text-decoration-none">
                LinkedIn
              </a>
            </div>*/}
          </Col>
          <Col md={2}>
            <h6 className="fw-semibold">Terms and Conditions</h6>
          </Col>
          <Col md={3}>
            <h6 className="fw-semibold text-md-end">
              © {new Date().getFullYear()} SEPL All rights reserved.
            </h6>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
